import React from "react";
import { handleEnquiryDownload, handleFollowupsDownload } from "./Master";
import usePrivateLink from "../../config/usePrivateLink";
import EnquiryTable from "./EnquiryTable";
import EnquiryFollowupTable from "./EnquiryFollowupTable";

export default function DashboardModal({
  setLoading,
  allFilter,
  setAllFilter,
}) {
  const hasAccess = usePrivateLink();
  const statusMap = {
    0: "Enquiry Pending",
    1: "Enquiry Admissions",
    2: "Enquiry Rejected",
    // 3: "Enquiry Followups",
    4: "Enquiry Demo",
    5: "Enquiry Visit",
  };

  return (
    <div
      className="modal fade"
      id="MainModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header bg-label-primary py-3">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Enquiry List
              {/* {JSON.stringify(allFilter)} */}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            {allFilter?.table === "enquiry" && (
              <div className="row g-2 align-items-center">
                <div className="col-sm-6">
                  <h4 className="text-primary m-0">
                    {" "}
                    {statusMap[allFilter.status] || "Enquiry List"}
                  </h4>
                </div>
                <div className="col-sm-6 text-end">
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    {hasAccess("/enquiry/export") && (
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() =>
                          handleEnquiryDownload("excel", setLoading, allFilter)
                        }
                      >
                        <i className="ri-file-excel-2-line me-2"></i> Download
                      </button>
                    )}
                    {hasAccess("/enquiry/print") && (
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() =>
                          handleEnquiryDownload("print", setLoading, allFilter)
                        }
                      >
                        <i className="ri-printer-line me-2"></i> Print
                      </button>
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <hr />
                  <div className="table-responsive">
                    <EnquiryTable
                      filters={allFilter}
                      setFilters={setAllFilter}
                    />
                  </div>
                </div>
              </div>
            )}

            {allFilter?.table === "followups" && (
              <div className="row g-2 align-items-center">
                <div className="col-sm-6">
                  <h4 className="text-primary m-0">Enquiry Followups List</h4>
                </div>
                <div className="col-sm-6 text-end">
                  <div className="d-flex align-items-center justify-content-end gap-2">
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() =>
                        handleFollowupsDownload("print", setLoading, allFilter)
                      }
                    >
                      <i className="ri-printer-line me-2"></i> Print
                    </button>
                  </div>
                </div>

                <div className="col-12">
                  <hr />
                  <div className="table-responsive">
                    <EnquiryFollowupTable
                      filters={allFilter}
                      setFilters={setAllFilter}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer  bg-label-primary py-3">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
